export function initVideoRowSliders() {
    const getVisibleSlides = () => {
        const width = window.innerWidth;
        if ( width <= 768 ) {
            return 1;
        }
        if ( width < 1200 ) {
            return 2;
        }
        return 3;
    };

    document.querySelectorAll( '.video-category-container' ).forEach( ( container ) => {
        [ 'top', 'bottom' ].forEach( ( rowType ) => {
            const track = container.querySelector( `.${ rowType }-track` );
            if ( ! track ) {
                return;
            }

            const slides = Array.from( track.querySelectorAll( '.video-slide' ) );
            if ( slides.length < 1 ) {
                return;
            }

            const prevBtn = container.querySelector( `.carousel-control-prev.${ rowType }` );
            const nextBtn = container.querySelector( `.carousel-control-next.${ rowType }` );
            const indicatorsWrapper = container.querySelector( `.carousel-indicators.${ rowType }` );

            let currentIndex = 0;
            let visibleSlides = getVisibleSlides();
            let slideWidth = slides[ 0 ].offsetWidth;

            const updateSlider = () => {
                track.style.transform = `translateX(-${ currentIndex * slideWidth }px)`;

                const maxIndex = Math.max( 0, slides.length - visibleSlides );
                const isMobile = visibleSlides === 1;

                if ( prevBtn ) {
                    prevBtn.classList.toggle( 'd-none', isMobile || currentIndex === 0 );
                    prevBtn.classList.toggle( 'd-flex', ! isMobile && currentIndex > 0 );
                }

                if ( nextBtn ) {
                    const hasNext = currentIndex < maxIndex;
                    nextBtn.classList.toggle( 'd-none', ! hasNext || isMobile );
                    nextBtn.classList.toggle( 'd-flex', hasNext && ! isMobile );
                }

                if ( indicatorsWrapper && isMobile && slides.length > 1 ) {
                    indicatorsWrapper.querySelectorAll( '.indicator-dot' ).forEach( ( dot, i ) => {
                        dot.classList.toggle( 'active', i === currentIndex );
                    } );
                }
            };

            const renderIndicators = () => {
                if ( ! indicatorsWrapper ) {
                    return;
                }
                indicatorsWrapper.innerHTML = '';

                if ( visibleSlides > 1 || slides.length <= 1 ) {
                    indicatorsWrapper.classList.add( 'd-none' );
                    return;
                }

                slides.forEach( ( _, i ) => {
                    const dot = document.createElement( 'span' );
                    dot.className = `indicator-dot rounded-circle${ i === currentIndex ? ' active' : '' }`;
                    dot.onclick = () => {
                        currentIndex = i;
                        updateSlider();
                    };
                    indicatorsWrapper.appendChild( dot );
                } );

                indicatorsWrapper.classList.remove( 'd-none' );
            };

            const updateDimensions = () => {
                visibleSlides = getVisibleSlides();
                slideWidth = slides[ 0 ].offsetWidth;
                renderIndicators();
                updateSlider();
            };

            const changeSlide = ( direction ) => {
                const maxIndex = Math.max( 0, slides.length - visibleSlides );
                currentIndex = Math.min( Math.max( currentIndex + direction * visibleSlides, 0 ), maxIndex );
                updateSlider();
            };

            if ( prevBtn ) {
                prevBtn.onclick = () => changeSlide( -1 );
            }
            if ( nextBtn ) {
                nextBtn.onclick = () => changeSlide( 1 );
            }

            window.addEventListener( 'resize', updateDimensions );
            updateDimensions();
        } );
    } );
}
